import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from 'ngx-sharebuttons';
import { SHARE_BUTTONS, SHARE_BUTTONS_CONFIG } from 'ngx-sharebuttons';
import * as i2 from 'ngx-sharebuttons/button';
import { ShareButtonModule } from 'ngx-sharebuttons/button';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i1 from '@fortawesome/angular-fontawesome';
function ShareButtons_div_0_share_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "share-button", 3);
    i0.ɵɵlistener("opened", function ShareButtons_div_0_share_button_1_Template_share_button_opened_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.opened.emit($event));
    })("closed", function ShareButtons_div_0_share_button_1_Template_share_button_closed_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closed.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("button", button_r3)("theme", ctx_r1.theme)("url", ctx_r1.url)("title", ctx_r1.title)("description", ctx_r1.description)("image", ctx_r1.image)("tags", ctx_r1.tags)("redirectUrl", ctx_r1.redirectUrl)("autoSetMeta", ctx_r1.autoSetMeta)("showIcon", ctx_r1.showIcon)("showText", ctx_r1.showText)("disabled", ctx_r1.disabled);
  }
}
function ShareButtons_div_0_expand_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "expand-button", 4);
    i0.ɵɵlistener("toggle", function ShareButtons_div_0_expand_button_2_Template_expand_button_toggle_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.updateState({
        expanded: $event
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const state_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("sb-button sb-", ctx_r1.theme, "");
    i0.ɵɵproperty("expanded", state_r5.expanded)("moreIcon", state_r5.moreIcon)("lessIcon", state_r5.lessIcon)("moreAriaLabel", state_r5.moreAriaLabel)("lessAriaLabel", state_r5.lessAriaLabel);
  }
}
function ShareButtons_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ShareButtons_div_0_share_button_1_Template, 1, 12, "share-button", 1)(2, ShareButtons_div_0_expand_button_2_Template, 1, 8, "expand-button", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const state_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("sb-group sb-", ctx_r1.theme, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", state_r5.selectedButtons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", state_r5.shownCount < state_r5.userButtons.length);
  }
}
let ExpandButton = /*#__PURE__*/(() => {
  class ExpandButton {
    constructor(el) {
      this.toggle = new EventEmitter();
      el.nativeElement.style.setProperty('--button-color', '#FF6651');
    }
    static {
      this.ɵfac = function ExpandButton_Factory(t) {
        return new (t || ExpandButton)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ExpandButton,
        selectors: [["expand-button"]],
        inputs: {
          moreIcon: "moreIcon",
          lessIcon: "lessIcon",
          expanded: "expanded",
          moreAriaLabel: "moreAriaLabel",
          lessAriaLabel: "lessAriaLabel"
        },
        outputs: {
          toggle: "toggle"
        },
        decls: 4,
        vars: 2,
        consts: [[1, "sb-wrapper", "sb-expand", "sb-show-icon", 3, "click"], [1, "sb-content"], [1, "sb-icon"], [3, "icon"]],
        template: function ExpandButton_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function ExpandButton_Template_button_click_0_listener() {
              return ctx.toggle.emit(!ctx.expanded);
            });
            i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "fa-icon", 3);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.expanded ? ctx.lessAriaLabel : ctx.moreAriaLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("icon", ctx.expanded ? ctx.lessIcon : ctx.moreIcon);
          }
        },
        dependencies: [i1.FaIconComponent],
        styles: ["[button=facebook][_nghost-%COMP%], [button=facebook]   [_nghost-%COMP%]{--button-color: #4267B2}[button=twitter][_nghost-%COMP%], [button=twitter]   [_nghost-%COMP%]{--button-color: #00acee}[button=google][_nghost-%COMP%], [button=google]   [_nghost-%COMP%]{--button-color: #db4437}[button=mix][_nghost-%COMP%], [button=mix]   [_nghost-%COMP%]{--button-color: #ff8226}[button=line][_nghost-%COMP%], [button=line]   [_nghost-%COMP%]{--button-color: #00b900}[button=linkedin][_nghost-%COMP%], [button=linkedin]   [_nghost-%COMP%]{--button-color: #006fa6}[button=pinterest][_nghost-%COMP%], [button=pinterest]   [_nghost-%COMP%]{--button-color: #bd081c}[button=reddit][_nghost-%COMP%], [button=reddit]   [_nghost-%COMP%]{--button-color: #ff4006}[button=tumblr][_nghost-%COMP%], [button=tumblr]   [_nghost-%COMP%]{--button-color: #36465d}[button=whatsapp][_nghost-%COMP%], [button=whatsapp]   [_nghost-%COMP%]{--button-color: #25d366}[button=messenger][_nghost-%COMP%], [button=messenger]   [_nghost-%COMP%]{--button-color: #0080FF}[button=telegram][_nghost-%COMP%], [button=telegram]   [_nghost-%COMP%]{--button-color: #0088cc}[button=xing][_nghost-%COMP%], [button=xing]   [_nghost-%COMP%]{--button-color: #006567}[button=sms][_nghost-%COMP%], [button=sms]   [_nghost-%COMP%]{--button-color: #20c16c}[button=email][_nghost-%COMP%], [button=email]   [_nghost-%COMP%]{--button-color: #FF961C}[button=viber][_nghost-%COMP%], [button=viber]   [_nghost-%COMP%]{--button-color: #665ca7}[button=vk][_nghost-%COMP%], [button=vk]   [_nghost-%COMP%]{--button-color: #4C75A3}[button=copy][_nghost-%COMP%], [button=copy]   [_nghost-%COMP%]{--button-color: #607D8B}[button=print][_nghost-%COMP%], [button=print]   [_nghost-%COMP%]{--button-color: #765AA2}[button=expand][_nghost-%COMP%], [button=expand]   [_nghost-%COMP%]{--button-color: #FF6651}button[_ngcontent-%COMP%]{cursor:pointer;position:relative;outline:0;-webkit-print-color-adjust:exact;margin:var(--sb-margin, .3125em);padding:var(--sb-padding, 0);min-width:var(--sb-min-width, 4.125em);height:var(--sb-height, 2.5em);color:var(--sb-color, #fff);background:var(--sb-background);font-size:var(--sb-font-size, 13px);line-height:var(--sb-line-height, 2.571em);border:var(--sb-border);border-radius:var(--sb-border-radius);transition:var(--sb-transition);box-shadow:var(--sb-box-shadow);text-shadow:var(--sb-text-shadow);overflow:var(--sb-overflow)}.sb-icon[_ngcontent-%COMP%], .sb-text[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;user-select:none}.sb-content[_ngcontent-%COMP%]{flex:1;display:flex;height:100%;width:100%;position:relative}.sb-text[_ngcontent-%COMP%]{flex:1;height:100%;white-space:nowrap;padding:var(--sb-text-padding, 0 .7em);font-weight:var(--sb-font-weight, bold)}.sb-icon[_ngcontent-%COMP%]{text-align:center;width:100%;height:100%;min-width:2em;font-size:var(--sb-icon-size, 1.2em)}"],
        changeDetection: 0
      });
    }
  }
  return ExpandButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ShareButtons = /*#__PURE__*/(() => {
  class ShareButtons {
    constructor(_share) {
      this._share = _share;
      this._state$ = new BehaviorSubject({
        includedButtons: [],
        excludedButtons: [],
        userButtons: [],
        selectedButtons: [],
        expanded: true,
        shownCount: Object.keys(SHARE_BUTTONS).length
      });
      this._configSub$ = Subscription.EMPTY;
      this.theme = this._share.config.theme;
      /** Sets the fb messenger redirect url to enable sharing on Messenger desktop */
      this.redirectUrl = this._share.config.redirectUrl;
      /** Show buttons icons */
      this.showIcon = true;
      /** Show buttons text */
      this.showText = false;
      /** Share dialog opened event */
      this.opened = new EventEmitter();
      /** Share dialog closed event */
      this.closed = new EventEmitter();
    }
    ngOnInit() {
      this.state$ = this._state$.pipe(map(state => {
        // Use component include buttons, otherwise fallback to the global include buttons
        const includedButtons = state.includedButtons && state.includedButtons.length ? state.includedButtons : state.userButtons;
        const userButtons = state.excludedButtons ? includedButtons.filter(btn => state.excludedButtons.indexOf(btn) < 0) : includedButtons;
        const selectedButtons = userButtons.slice(0, state.expanded ? userButtons.length : state.shownCount);
        return {
          userButtons,
          selectedButtons,
          expanded: state.expanded,
          shownCount: state.shownCount,
          moreIcon: state.moreIcon,
          lessIcon: state.lessIcon,
          moreAriaLabel: state.moreAriaLabel,
          lessAriaLabel: state.lessAriaLabel
        };
      }));
      // Subscribe to share buttons config changes, This updates the component whenever a new button is added
      this._configSub$ = this._share.config$.subscribe(config => {
        // Use global include buttons, otherwise fallback to all buttons
        const includedButtons = config.include.length ? config.include : Object.keys(SHARE_BUTTONS);
        const userButtons = includedButtons.filter(btn => config.exclude.indexOf(btn) < 0);
        this.updateState({
          userButtons,
          expanded: false,
          moreIcon: config.moreButtonIcon,
          lessIcon: config.lessButtonIcon,
          moreAriaLabel: config.moreButtonAriaLabel,
          lessAriaLabel: config.lessButtonAriaLabel
        });
      });
    }
    ngOnChanges(changes) {
      const shouldUpdate = changes['include'] && changes['include'].currentValue !== changes['include'].previousValue || changes['exclude'] && changes['exclude'].currentValue !== changes['exclude'].previousValue || changes['show'] && changes['show'].currentValue !== changes['show'].previousValue;
      if (shouldUpdate) {
        this.updateState({
          includedButtons: this.include,
          excludedButtons: this.exclude,
          shownCount: this.show
        });
      }
    }
    ngOnDestroy() {
      this._configSub$.unsubscribe();
      this._state$.complete();
    }
    updateState(state) {
      this._state$.next({
        ...this._state$.value,
        ...state
      });
    }
    static {
      this.ɵfac = function ShareButtons_Factory(t) {
        return new (t || ShareButtons)(i0.ɵɵdirectiveInject(i1$1.ShareService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ShareButtons,
        selectors: [["share-buttons"]],
        inputs: {
          theme: "theme",
          include: "include",
          exclude: "exclude",
          show: "show",
          url: "url",
          title: "title",
          description: "description",
          image: "image",
          tags: "tags",
          redirectUrl: "redirectUrl",
          autoSetMeta: "autoSetMeta",
          showIcon: "showIcon",
          showText: "showText",
          disabled: "disabled"
        },
        outputs: {
          opened: "opened",
          closed: "closed"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 3,
        consts: [[3, "class", 4, "ngIf"], [3, "button", "theme", "url", "title", "description", "image", "tags", "redirectUrl", "autoSetMeta", "showIcon", "showText", "disabled", "opened", "closed", 4, "ngFor", "ngForOf"], [3, "class", "expanded", "moreIcon", "lessIcon", "moreAriaLabel", "lessAriaLabel", "toggle", 4, "ngIf"], [3, "opened", "closed", "button", "theme", "url", "title", "description", "image", "tags", "redirectUrl", "autoSetMeta", "showIcon", "showText", "disabled"], [3, "toggle", "expanded", "moreIcon", "lessIcon", "moreAriaLabel", "lessAriaLabel"]],
        template: function ShareButtons_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ShareButtons_div_0_Template, 3, 5, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.state$));
          }
        },
        dependencies: [i2.ShareButton, i3.NgForOf, i3.NgIf, ExpandButton, i3.AsyncPipe],
        styles: ["[_nghost-%COMP%]{display:inherit}.sb-group[_ngcontent-%COMP%], .sb-button[_ngcontent-%COMP%]{display:inline-flex;align-items:flex-start}.sb-group[_ngcontent-%COMP%]{flex-wrap:wrap}"],
        changeDetection: 0
      });
    }
  }
  return ShareButtons;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ShareButtonsModule = /*#__PURE__*/(() => {
  class ShareButtonsModule {
    static withConfig(config) {
      return {
        ngModule: ShareButtonsModule,
        providers: [{
          provide: SHARE_BUTTONS_CONFIG,
          useValue: config
        }]
      };
    }
    static {
      this.ɵfac = function ShareButtonsModule_Factory(t) {
        return new (t || ShareButtonsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ShareButtonsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [ShareButtonModule, CommonModule, ShareButtonModule]
      });
    }
  }
  return ShareButtonsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ShareButtons, ShareButtonsModule };
